import React from "react";
import { Plus, Trash } from "@phosphor-icons/react";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";

export default function RecipeSteps({ steps, onChange }) {
  const addStep = () => {
    if ((steps || []).length >= 30) return;
    const next = (steps || []).length + 1;
    onChange([...(steps || []), { step_no: next, description: "", time_min: 0 }]);
  };
  const updateStep = (idx, patch) => {
    const arr = (steps || []).map((s, i) => (i === idx ? { ...s, ...patch } : s));
    onChange(arr);
  };
  const removeStep = (idx) => {
    const arr = (steps || []).filter((_, i) => i !== idx).map((s, i) => ({ ...s, step_no: i + 1 }));
    onChange(arr);
  };

  return (
    <div className="kostra-card p-5 md:p-6" data-testid="recipe-steps-card">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3 className="kostra-section-title text-xl">Recipe Method</h3>
          <p className="text-xs text-[#4B5563] mt-1">Up to 30 cooking steps with time tracking.</p>
        </div>
        <span className="text-xs text-[#4B5563]">
          {(steps || []).length}/30 steps
        </span>
      </div>

      <div className="space-y-3">
        {(steps || []).length === 0 && (
          <p className="text-sm text-[#4B5563] py-4 text-center">No steps yet — add your first cooking step below.</p>
        )}
        {(steps || []).map((s, idx) => (
          <div key={idx} className="flex flex-col md:flex-row gap-3 items-start p-3 rounded-md bg-[#F9FAFB] border border-[#E5E7EB]">
            <div className="h-9 w-9 rounded-md bg-[#0A3B24] text-white font-mono-num font-semibold inline-flex items-center justify-center shrink-0">
              {idx + 1}
            </div>
            <Textarea
              value={s.description}
              onChange={(e) => updateStep(idx, { description: e.target.value })}
              placeholder="Describe this step..."
              rows={2}
              className="flex-1"
              data-testid={`step-desc-${idx}`}
            />
            <div className="flex items-center gap-2 shrink-0">
              <Input
                type="number"
                min="0"
                step="1"
                value={s.time_min}
                onChange={(e) => updateStep(idx, { time_min: parseFloat(e.target.value) || 0 })}
                className="w-24 font-mono-num"
                placeholder="min"
                data-testid={`step-time-${idx}`}
              />
              <span className="text-xs text-[#4B5563]">min</span>
              <button
                type="button"
                onClick={() => removeStep(idx)}
                className="h-9 w-9 inline-flex items-center justify-center rounded-md text-[#4B5563] hover:bg-[#FBE8E8] hover:text-[#DC2626] transition"
                aria-label="Remove step"
                data-testid={`step-remove-${idx}`}
              >
                <Trash size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-4">
        <Button
          type="button"
          onClick={addStep}
          disabled={(steps || []).length >= 30}
          className="bg-[#0A3B24] hover:bg-[#0E5232] text-white"
          data-testid="add-step-btn"
        >
          <Plus size={16} weight="bold" className="mr-1" /> Add Step
        </Button>
      </div>
    </div>
  );
}
